const langs = ['pl', 'en', 'de', 'ua']
export default langs